<template>
    <div class="bundling">
         <div class="bundling-list"   ref="bundlingContainer"   @mousedown="startScroll" @mouseup="stopScroll" @mouseleave="stopScroll" @mousemove="onScroll">
            <div class="bundling-left"  v-for="(item, index) in goods.bundlingGoods" :key="index" >
            <div class="lef-box" @click="goSku(item)">
                <div class="box-not">
                    <img :src="$img(item.sku_image)" alt="">
                    <p class="box-name">{{ item.sku_name }}</p>
                    <ctrlShowText :info="item" type="custom" size="12px" margin="0 0 10px 0" gap="12px"
                    :wesArr="['规格','数量','效期','厂家']" :traArr="['规格','数量','生产日期','厂家']"></ctrlShowText>
                    <template v-if="$store.getters.token">
                        <p class="box-pirce" v-if="item.sale_control.view_price || item.sale_control.is_member_by"><span
                                class="font-si">￥</span>{{ item.promotion_price }}</p>
                        <p class="box-pirce" v-else><span class="font-si">￥</span>{{ item.sale_control.not_buy_msg }}</p>
                    </template>
                    <template v-else>
                        <p class="box-pirce"><span class="font-si">￥</span>登录可见</p>
                    </template>
                </div>

            </div>
            <div class="lef-jia" v-if="index != goods.bundlingGoods.length - 1">+</div>
        </div>
         </div>
        <span class="bundling-deng">=</span>
        <div class="bundling-rgint">
            <h4>组合套餐价</h4>
            <template v-if="$store.getters.token">
                <template v-if="goods.sale_control.is_member_by && goods.sale_control.view_price">
                    <del>原价：{{ goods.goods_money }}元</del>
                    <p class="rgint-pirce">￥{{ goods.bl_price }}</p>
                </template>
                <template v-else>
                    <del>{{ goods.sale_control.not_buy_msg }}</del>
                    <p class="rgint-pirce" style="font-size: 18px">￥{{ goods.sale_control.not_buy_msg }}</p>
                </template>
            </template>
            <template v-else>
                <del>原价：登录可见</del>
                <p class="rgint-pirce" style="font-size: 18px">￥登录可见</p>
            </template>
            <template v-if="$store.getters.token">
                <div class="rgint-add"
                    :class="goods.sale_control && goods.sale_control?.view_price ? 'rgint-add' : 'ban'"
                    @click="joinCart(goods)">
                    <span class="into">加入购物车</span>
                </div>
            </template>
            <template v-else>
                <div class="rgint-add" @click="joinCart(goods)">
                    <span class="into">加入购物车</span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { onTip } from "@/utils/tips"
import { joinCart } from "@/api/promotion/bundling"
import ctrlShowText from "@/components/ctrl-show-text/ctrl-show-text.vue";
export default {
    components: {ctrlShowText},
    props: {
        goods: {
            required: true,
            type: Object
        },
    },
    data() {
        return {
            number: 1,
            isScrolling: false,
            startX: 0,
            scrollLeft: 0,
        }
    },
    methods: {
        goSku(item) {
            if (!this.$store.getters.token) {
                this.$router.pushToTab("/login")
                return
            }
            if (onTip(item.sale_control.view_price, item.sale_control.is_member_by, this, item.sale_control.not_buy_msg)) return
            this.$router.pushToTab("/sku-" + item.sku_id)
        },
        // bundingGoodsJoinCart(goods) {
        //     console.log(goods)
        //     joinCart({
        //         id: goods.bl_id,
        //         num: 1
        //     })
        // },
        // 加入购物车
        joinCart(item) {
            if (onTip(item.sale_control?.view_price, item.sale_control?.is_member_by, this, item.sale_control?.not_buy_msg)) return
            joinCart({
                id: item.bl_id,
                num: this.number
            }).then((res) => {
                if (res.code === 0) {
                    this.$message({
                        message: "加入购物车成功",
                        type: "success"
                    })
                }
            }).catch((err) => {
                if (err.message === "token不存在") {
                    this.$router.pushToTab("/login")
                } else {
                    this.$message.error(err.message)
                }
            })
        },
        startScroll(e) {
            this.isScrolling = true;
            this.startX = e.pageX - this.$refs.bundlingContainer.offsetLeft;
            this.scrollLeft = this.$refs.bundlingContainer.scrollLeft;
        },
        stopScroll() {
            this.isScrolling = false;
        },
        onScroll(e) {
            if (!this.isScrolling) return;
            e.preventDefault();
            const x = e.pageX - this.$refs.bundlingContainer.offsetLeft;
            const walk = (x - this.startX) * 2; // 滚动速度
            this.$refs.bundlingContainer.scrollLeft = this.scrollLeft - walk;
        },
    },
}
</script>

<style lang="scss" scoped>
.bundling {
    -webkit-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
user-select: none;
    padding: 20px;
    display: flex;
    // width: 500px;
    // flex-wrap: wrap;
    box-sizing: border-box;

    .font-si {
        font-size: 14px;
    }
    &-list{
        width: 350px;
        display: flex;
        overflow-x: scroll;
    }
    &-left {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // flex-wrap: wrap;

        .lef-box {
            cursor: pointer;

            img {
                width: 147px;
                height: 147px;
            }
        }

        .lef-jia {
            margin: 0px 20px 30px 20px;
            font-size: 30px;
            color: #b0b0b0;

        }

        .box-name {
            width: 147px;
                    height: 35px;
                    line-height: 18px;
            margin-top: 5px;
            word-break: break-all;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            font-weight: bolder;
        }

        .box-pirce {
            font-weight: bold;
            font-size: 18px;
        }
    }

    &-deng {
        margin: 60px 20px 30px 20px;
        font-size: 30px;
        color: #b0b0b0;
    }

    &-rgint {
        width: 147px;
        text-align: center;
        background-image: linear-gradient(181.2deg, rgb(255, 84, 123) 2.5%, rgb(254, 254, 254) 45.8%);
        cursor: pointer;

        h4 {
            font-size: 16px;
            color: #fff;
            margin: 10px 0 30px 0;
        }

        del {
            font-size: 12px;
            color: #b0b0b0;
        }

        p {
            font-size: 25px;
            color: red;
            font-weight: bolder;
            margin-bottom: 25px;
        }

        .rgint-add {
            .into {
                cursor: pointer;
                width: 80px;
                border: 1px solid #FF457E;
                padding: 8px 10px;
                border-radius: 5px;
                color: #FF457E;
            }
        }

        .ban {
            .into {
                cursor: not-allowed;
                width: 80px;
                border: 1px solid #dddddd6e;
                background: #dddddd6e;
                padding: 8px 10px;
                border-radius: 5px;
                color: white;
            }
        }
    }
    .factory {
     
     line-height: 18px;
     height: 33px;
     word-wrap: break-word;
     word-break: break-word;
     white-space: normal;
     display: -webkit-box;
     -webkit-box-orient: vertical;
     -webkit-line-clamp: 2;
     overflow: hidden;
     text-overflow: ellipsis;
 }
.factory-t{
     margin-top: 10px;
 }
 ::-webkit-scrollbar {
        width: 5px;
        height: 8px;
        background-color: #f9f9f9;


    }

    ::-webkit-scrollbar-thumb {
        background-color: #ff547b;
        border-radius: 10px;
        transition: background-color 0.2s ease;


    }

}


</style>
<style>
/* .bundling  .bundling-left :last-child  div{
        display: none;
    } */
</style>
